(function () {
  const modal = document.getElementById('need-help');
  if (!modal) return;

  function updateAnnouncementBarHeight() {
    const announcementBar =
      document.querySelector('.announcement-bar') ||
      document.querySelector('[class*="announcement"]');
    const headerGroup = document.querySelector(
      '.shopify-section-group-header-group'
    );
    let height = 0;

    if (headerGroup) {
      height = headerGroup.offsetHeight;
    } else if (announcementBar) {
      height = announcementBar.offsetHeight;
    }

    modal.style.setProperty('--announcement-bar-height', height + 'px');
  }

  // Update height when modal opens
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === 'open' && modal.hasAttribute('open')) {
        updateAnnouncementBarHeight();
        document.body.classList.add('tw-overflow-hidden');
      } else if (
        mutation.attributeName === 'open' &&
        !modal.hasAttribute('open')
      ) {
        document.body.classList.remove('tw-overflow-hidden');
      }
    });
  });

  observer.observe(modal, { attributes: true });

  // Close on backdrop click
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.close();
    }
  });

  // Clean up body class on close
  modal.addEventListener('close', () => {
    document.body.classList.remove('tw-overflow-hidden');
  });
})();
